export interface ILogin {
  session_id: string;
  client_id: string;
  auth_params: string;
  id: string;
  password: string;
  ticket: string;
}

export class LoginValues implements ILogin {
  session_id: string = '';
  client_id: string = '';
  auth_params: string = '';
  id: string = '';
  password: string = '';
  ticket: string = '';

  constructor(init?: ILogin) {
    Object.assign(this, init);
  }
}

export interface ILoginEmailPassword {
  session_id: string;
  client_id: string;
  auth_params: string;
  email: string;
  password: string;
  ticket: string;
  auth_type: number;
  // auth_placeholder: string;
  select_options: SelectOption[];
}

export class LoginValuesEmailPassword implements ILoginEmailPassword {
  session_id: string = '';
  client_id: string = '';
  auth_params: string = '';
  email: string = '';
  password: string = '';
  ticket: string = '';
  auth_type: number = 0;
  // auth_placeholder: string = '';
  select_options: SelectOption[] = [];

  constructor(init?: ILoginEmailPassword) {
    Object.assign(this, init);
  }
}
export interface SelectOption {
  key: number;
  text: string;
  value: string;
}
export interface IgetAuthCode {
  code: string;
}

export interface ILoginEmailBirthday {
  session_id: string;
  client_id: string;
  auth_params: string;
  email: string;
  birthday: string;
  ticket: string;
}

export class LoginValuesEmailBirthday implements ILoginEmailBirthday {
  session_id: string = '';
  client_id: string = '';
  auth_params: string = '';
  email: string = '';
  birthday: string = '';
  ticket: string = '';

  constructor(init?: ILoginEmailBirthday) {
    Object.assign(this, init);
  }
}
